import { ArrowRight01Icon } from '@hugeicons/react'
import clsx from 'clsx'

import { getPrimaryResourceType } from '@/shared/resourceModuleParity'
import { Badge } from '@/shared/ui/Badge'
import { Card } from '@/shared/ui/Card'
import { ProgressBar } from '@/shared/ui/ProgressBar'
import { ResourceModuleIcon } from '@/shared/ui/ResourceModuleIcon'
import { RewardPill } from '@/shared/ui/RewardPill'
import type { ObjectiveWithProgress } from '@/types/objective'

import {
  getProgressData,
  progressLabel,
  progressVariant
} from '../model/progress'

export function getObjectiveResourceType(
  objective: ObjectiveWithProgress
): string | undefined {
  return getPrimaryResourceType(objective.objective_conditions)
}

type Props = { objective: ObjectiveWithProgress; onPress?: () => void }

export const ObjectiveItem = ({ objective, onPress }: Props) => {
  const { name, coin_reward, completed } = objective
  const { sumCurrent, sumTarget, percent } = getProgressData(objective)
  const pVariant = progressVariant(completed, percent)
  const resourceType = getObjectiveResourceType(objective)

  return (
    <Card
      onClick={onPress}
      className={clsx('cursor-pointer shadow-sm', !onPress && 'cursor-default')}
    >
      <Card.Body>
        <div className="flex items-start gap-2 sm:gap-3">
          <ResourceModuleIcon
            resourceType={resourceType}
            size={20}
            tileSize={44}
            completed={completed}
          />

          <div className="flex min-w-0 flex-1 flex-col gap-1.5">
            {completed && (
              <div className="flex flex-wrap items-center gap-1.5">
                <Badge variant="success" size="sm" showIcon={false}>
                  Concluído
                </Badge>
              </div>
            )}

            <h3 className="m-0 line-clamp-2 text-sm font-bold leading-snug text-gray-900">
              {name}
            </h3>

            <ProgressBar.Row
              value={completed ? 100 : percent}
              variant={pVariant}
              size="sm"
              label={progressLabel(completed, sumCurrent, sumTarget)}
            />
          </div>

          <div className="flex w-[70px] shrink-0 flex-col items-end gap-2 self-stretch">
            <ArrowRight01Icon
              size={16}
              variant="stroke"
              className="text-gray-600"
              aria-hidden
            />

            <RewardPill type="coins" value={coin_reward} className="mt-auto" />
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}
